import { useAppInitialize } from '@/app/_model/useAppInitialize';
import { useBackspaceNavigation } from '@/app/_model/useBackspaceNavigation';
import { useDeepLink } from '@/app/_model/useDeepLink';
import { AppProviders } from '@/app/_providers/AppProviders';
import { AppRouter } from '@/app/router';
import { FallbackScreen, PopUpModal } from '@/shared/ui';

import '@/styles/out_globals.css';
import '@/styles/toast.css';
import '@material-design-icons/font';
import '@splidejs/react-splide/css';

const App = () => {
  const { status, reason, retry } = useAppInitialize();

  useBackspaceNavigation();
  useDeepLink();

  return (
    <AppProviders>
      {status === 'ready' ? (
        <AppRouter />
      ) : status === 'error' ? (
        <FallbackScreen reason={reason} onRetry={retry} />
      ) : null}

      <PopUpModal />
    </AppProviders>
  );
};

export default App;
